import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthHttpInterceptor } from './auth-http.interceptor';
import { ErrorHttpInterceptor } from './error-http.interceptor';
import { UnitHttpInterceptor } from './unit-http.interceptor';
import { ProgressHttpInterceptor } from './/progress-http.interceptor';

export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ProgressHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: UnitHttpInterceptor, multi: true }
];
